import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import TaniumConfligListing from './TaniumConfligListing';
import TaniumCredentialsForm from './TaniumCredentialsForm';

const TaniumPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={TaniumCredentialsForm}
        PullConfigListingView={TaniumConfligListing}
     />
);

export default TaniumPullAndPushView;
